module.exports = __webpack_public_path__ + "static/img/v9.0d5663a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v9.svg
// module id = Ldat
// module chunks = 0